import { useEffect, useState } from 'react';

import { strings } from '../strings';
import type { Affiliation } from '../types/affiliation';
import { fetchAffiliation } from '../utils/affiliation';

export const useAffiliation = () => {
  const [affiliation, setAffiliation] = useState<Affiliation | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetchAffiliation()
      .then(fetchedAffiliation => {
        if (!isMounted) {
          return;
        }

        if (fetchedAffiliation.text === '' || fetchedAffiliation.url === '') {
          setAffiliation(null);
          setIsLoading(false);
          return
        }

        setAffiliation(fetchedAffiliation);
        setIsLoading(false);
      })
      .catch(caughtError => {
        if (!isMounted) {
          return;
        }

        console.error('Failed to fetch affiliation', caughtError);
        setError(strings.unableToLoadAffiliation);
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { affiliation, isLoading, error };
};